/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_CustomerService_Dtos_Broker_BrokerTaxGovermentDocumentDto } from '../models/Wealthlane_CustomerService_Dtos_Broker_BrokerTaxGovermentDocumentDto';
import type { Wealthlane_CustomerService_Dtos_Broker_TaxCertificationItemDto } from '../models/Wealthlane_CustomerService_Dtos_Broker_TaxCertificationItemDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class BrokerParticipantInfoService {

    /**
     * @param particiantId
     * @returns Wealthlane_CustomerService_Dtos_Broker_TaxCertificationItemDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiBrokerParticipantInfoCertificationDocuments(
        particiantId: string,
    ): CancelablePromise<Array<Wealthlane_CustomerService_Dtos_Broker_TaxCertificationItemDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/broker-participant-info/{particiantId}/certification-documents',
            path: {
                'particiantId': particiantId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param particiantId
     * @returns Wealthlane_CustomerService_Dtos_Broker_BrokerTaxGovermentDocumentDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiBrokerParticipantInfoGovernmentDocuments(
        particiantId: string,
    ): CancelablePromise<Array<Wealthlane_CustomerService_Dtos_Broker_BrokerTaxGovermentDocumentDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/broker-participant-info/{particiantId}/government-documents',
            path: {
                'particiantId': particiantId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
